export const years = ["2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"];

export const months = [
  {id: 1, text: "January"}, {id: 2, text: "February"}, {id: 3, text: "March"},
  {id: 4, text: "April"}, {id: 5, text: "May"}, {id: 6, text: "June"},
  {id: 7, text: "July"}, {id: 8, text: "August"}, {id: 9, text: "September"},
  {id: 10, text: "October"}, {id: 11, text: "November"}, {id: 12, text: "December"}
];

export const emailRegex = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
